import { IconMessageChatbot } from "@exopengithub/exokit";
import { IconSettings } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import { NavItem } from "./NavItem";
import { AI_PRODUCT_NAME } from "src/common/branding.js";
import { useUser } from "src/common/context/userContextUtils.js";
import { COMPANYADMIN } from "src/common/service/users.js";
import { useLoadedCompanyDomain } from "src/routes/routeDataHooks.js";
import { useHasExopenAiAccess } from "src/features/ai-chat/hooks/useHasExopenAiAccess.js";

// Rendered via renderFooter so it shares one block with Support/Language, not a separate section.
export const CompanySidebarFooterLinks = () => {
	const { t } = useTranslation();
	const companyDomain = useLoadedCompanyDomain();
	const user = useUser();
	const hasCompanyAdmin = user.hasPermissions(companyDomain.id, [COMPANYADMIN]);
	const hasExopenAiAccess = useHasExopenAiAccess(companyDomain.id);

	return (
		<>
			{hasCompanyAdmin && (
				<div className="mb-2 space-y-1">
					<NavItem
						to={`/company-domains/${companyDomain.id}/settings`}
						label={t("Settings")}
						icon={<IconSettings />}
					/>
				</div>
			)}
			{hasExopenAiAccess && (
				<div className="mb-2 space-y-1">
					<NavItem
						label={AI_PRODUCT_NAME}
						to={`/company-domains/${companyDomain.id}/ai-chat`}
						icon={<IconMessageChatbot />}
						data-testid="sidebar-ai-chat-link"
					/>
				</div>
			)}
		</>
	);
};
